import * as Utils from './util';

const set = (obj, path, value, rowIndex) => {
    for (let i = 1; i < path.length; i += 1) {
        if (i === path.length - 1) {
            if (rowIndex >= 0 && path[0].includes('[]') && path[0].replace('[]', '') in obj) {
                obj[path[0].replace('[]', '')][rowIndex][path[i]] = value;
            } else if (rowIndex >= 0 && path[i].includes('[]') && path[i].replace('[]', '') in obj) {
                obj[path[i].replace('[]', '')][rowIndex] = value;
            } else {
                obj[path[i]] = value;
            }
        } else if (rowIndex >= 0 && path[0].includes('[]') && path[0].replace('[]', '') in obj) {
            obj = obj[path[0].replace('[]', '')][rowIndex][path[i]];
        } else if (rowIndex >= 0 && path[i].includes('[]') && path[i].replace('[]', '') in obj) {
            obj = obj[path[i].replace('[]', '')][rowIndex];
        } else {
            obj = obj[path[i]];
        }
    }
};

export default class HandlerChange {
    static onSelectChange(event) {
        const { value } = event.target;
        const propsArr = event.target.name.split('.');
        if (propsArr.length > 1) {
            const model = { ...this.state[propsArr[0]] };
            set(model, propsArr, value);
            this.setState({ [propsArr[0]]: model });
        } else {
            this.setState({ [propsArr[0]]: value });
        }
    }

    static onSelectMultipleChange(props, values) {
        const propsArr = props.split('.');
        if (propsArr.length > 1) {
            const model = { ...this.state[propsArr[0]] };
            set(model, propsArr, values);
            this.setState({ [propsArr[0]]: model });
        } else {
            this.setState({ [propsArr[0]]: values });
        }
    }

    static onInputChange(event) {
        const { value } = event.target;
        const propsArr = event.target.name.split('.');
        if (propsArr.length > 1) {
            const model = { ...this.state[propsArr[0]] };
            set(model, propsArr, value);
            this.setState({ [propsArr[0]]: model });
        } else {
            this.setState({ [propsArr[0]]: value });
        }
    }

    static onInputAutocompleteChange(props, value) {
        const propsArr = props.split('.');
        if (propsArr.length > 1) {
            const model = { ...this.state[propsArr[0]] };
            set(model, propsArr, value);
            this.setState({ [propsArr[0]]: model });
        } else {
            this.setState({ [propsArr[0]]: value });
        }
    }

    static onDateChange(props, date) {
        const propsArr = props.split('.');
        if (propsArr.length > 1) {
            const model = { ...this.state[propsArr[0]] };
            set(model, propsArr, date);
            this.setState({ [propsArr[0]]: model });
        } else {
            this.setState({ [propsArr[0]]: date });
        }
    }

    static onIssueCardChange(props, item) {
        const propsArr = props.split('.');
        if (propsArr.length > 1) {
            const model = { ...this.state[propsArr[0]] };
            set(model, propsArr, item);
            this.setState({ [propsArr[0]]: model });
        } else {
            this.setState({ [propsArr[0]]: item });
        }
    }

    static onFilterChange(props, item) {
        const propsArr = props.split('.');
        if (propsArr.length > 1) {
            const model = { ...this.state[propsArr[0]] };
            set(model, propsArr, item);
            this.setState({ [propsArr[0]]: model });
        } else {
            this.setState({ [propsArr[0]]: item });
        }
    }

    static onValueChange = ((e, value, modelState, numericOptions, callback) => {
        if (!numericOptions) {
            numericOptions = {
                prefix: '',
                suffix: '',
                decimalSymbol: ',',
                allowNegative: false,
                includeThousandsSeparator: true,
                thousandsSeparatorSymbol: '.',
                decimalLimit: 2,
                allowDecimal: true,
                requireDecimal: true,
                allowLeadingZeroes: false,
            };
        }

        let propsArr = [];

        let model;
        if (typeof e === 'string') {
            propsArr = e.split('.');

            model = { ...modelState[propsArr[0]] };
            set(model, propsArr, value);
        } else {
            propsArr = e.target.name.split('.');
            model = { ...modelState[propsArr[0]] };

            if (propsArr.length > 1) {
                switch (e.target.type) {
                    case 'checkbox':
                        value = e.target.checked;
                        if ('clearfields' in e.target.attributes && e.target.attributes.clearfields.nodeValue
                            && e.target.attributes.clearfields.nodeValue !== '' && e.target.checked === false) {
                            const propsClear = e.target.attributes.clearfields.nodeValue.split(',');
                            clearFields(model, propsClear);
                        }
                        break;
                    case 'number':
                        value = e.target.value;
                        break;
                    case 'text':
                        if (e.target.id.split('_')[2] && e.target.id.split('_')[2] === 'numeric') {
                            value = Utils.convertToFloat(e.target.value, numericOptions);
                        } else {
                            value = e.target.value;
                        }
                        break;
                    default:
                        value = e.target.value;
                        break;
                }
                set(model, propsArr, value);
            } else {
                set(model, propsArr, value);
            }
        }

        if (callback) {
            callback(propsArr[0], model);
        }
    });

    static onRowChange = ((e, value, model, numericOptions, callback) => {
        if (!numericOptions) {
            numericOptions = {
                prefix: '',
                suffix: '',
                decimalSymbol: ',',
                allowNegative: false,
                includeThousandsSeparator: true,
                thousandsSeparatorSymbol: '.',
                decimalLimit: 2,
                allowDecimal: true,
                requireDecimal: true,
                allowLeadingZeroes: false,
            };
        }
        let propsArr = [];
        let propName = '';
        if (typeof e === 'string') {
            propName = e;
            propsArr = e.split('.');
        } else {
            propName = e.target.name;
            propsArr = e.target.name.split('.');
        }

        let rowIndex = 0;

        if ('rowindex' in e.target.attributes && e.target.attributes.rowindex.nodeValue && e.target.attributes.rowindex.nodeValue !== '') {
            rowIndex = e.target.attributes.rowindex.nodeValue;
        }

        if (propsArr.length > 1) {
            switch (e.target.type) {
                case 'checkbox':
                    set(model, propsArr, e.target.checked, rowIndex);
                    if ('clearfields' in e.target.attributes && e.target.attributes.clearfields.nodeValue
                        && e.target.attributes.clearfields.nodeValue !== '' && e.target.checked === false) {
                        const propsClear = e.target.attributes.clearfields.nodeValue.split(',');

                        clearFields(model, propsClear, rowIndex);
                    }
                    break;
                default:
                    if (e.target.id.split('_')[2] && e.target.id.split('_')[2] === 'numeric') {
                        set(model, propsArr, Utils.convertToFloat(e.target.value, numericOptions), rowIndex);
                    } else {
                        set(model, propsArr, e.target.value, rowIndex);
                    }
                    break;
            }
        } else {
            set(model, propsArr, value, rowIndex);
        }

        if (callback) {
            callback(propName, model);
        }
    });

    static setValue = (obj, path, value, rowIndex) => {
        set(obj, path, value, rowIndex);
    }
}

const clearFields = (model, propsClear, rowIndex) => {
    propsClear.forEach((field) => {
        field = field.replace(' ', '');
        const fieldClear = field.split('.');

        if (rowIndex >= 0) {
            const element = document.getElementsByName(field.replace('[]', ''))[rowIndex];
            if (element) {
                if (element === 'checkbox') {
                    element.checked = false;
                    set(model, fieldClear, false, rowIndex);
                } else {
                    element.value = '';
                    set(model, fieldClear, '', rowIndex);
                }
            } else {
                set(model, fieldClear, '', rowIndex);
            }
        } else {
            const element = document.getElementsByName(field)[0];
            if (element) {
                if (element === 'checkbox') {
                    element.checked = false;
                    set(model, fieldClear, false);
                } else {
                    element.value = '';
                    set(model, fieldClear, '');
                }
            } else {
                set(model, fieldClear, '');
            }
        }
    });
};
